import * as React from "react"
import {useEffect} from "react"

import {AppWrapperPage} from "../../@componets";
import {pageTitle} from "../../@signals";


export default function MinimalLayoutWrapperPage({ children, ...props }) {
    useEffect(() => {
        if (props.title) pageTitle.value = props.title
    }, [props.title])

    return <AppWrapperPage {...props}>
		{children}
    </AppWrapperPage>
}